import { EntityStatusTypes } from "@enums/entity-status-types";
import { FormattedRpServiceConfigurationServiceOffering } from "@idw-types/data/rp-service-configuration";
import { sortNumbers } from "@utils/number-util";

export const getSelectedServiceOfferings = (
    serviceOfferings: Array<FormattedRpServiceConfigurationServiceOffering>,
    filteredServiceOfferingIds: Array<string>
) => {
    return serviceOfferings
        .filter(so =>
            filteredServiceOfferingIds.includes(so.serviceOfferingID) &&
            so.fallbackStatus === "primary" &&
            so.addedToService &&
            so.status === EntityStatusTypes.ACTIVE
        )
        .sort((a, b) => sortNumbers(a.order, b.order));
};

export const getUnselectedServiceOfferings = (
    serviceOfferings: Array<FormattedRpServiceConfigurationServiceOffering>,
    selectedServiceOfferings: Array<FormattedRpServiceConfigurationServiceOffering>,
    filteredServiceOfferingIds: Array<string>
) => {
    const selectedServiceOfferingIds = selectedServiceOfferings.map(sso => sso.serviceOfferingID);

        const finalUnselectedServiceOfferings: Array<FormattedRpServiceConfigurationServiceOffering> = [];
        serviceOfferings.forEach(so => {
            if (
                filteredServiceOfferingIds.includes(so.serviceOfferingID) &&
                !selectedServiceOfferingIds.includes(so.serviceOfferingID) &&
                !finalUnselectedServiceOfferings.some(unselectedSO => unselectedSO.serviceOfferingID === so.serviceOfferingID)
            ) {
                finalUnselectedServiceOfferings.push(so);
            }
        });

        return finalUnselectedServiceOfferings;
};